module.exports = __webpack_public_path__ + "img/perspectives-slide10.79fadc6c.jpg";